import { defineMessages } from 'react-intl';

/**
 * The "2 working" / "1 failed" pill of the Work menu entry (design release-kit r7, t3). The
 * native Work screen renders the same ids.
 */
export const workBadgeMessages = defineMessages({
  working: { id: 'app.sml.promote.work.badge.working', defaultMessage: '{count} working' },
  failed: { id: 'app.sml.promote.work.badge.failed', defaultMessage: '{count} failed' },
  workingText: {
    id: 'app.sml.promote.work.badge.workingText',
    defaultMessage: '{count, plural, one {MUSIC24 is making # asset.} other {MUSIC24 is making # assets.}}',
  },
  failedText: {
    id: 'app.sml.promote.work.badge.failedText',
    defaultMessage: '{count, plural, one {# asset failed.} other {# assets failed.}}',
  },
});
